const isDialog = (dialog: unknown): dialog is HTMLDialogElement => {
    return dialog instanceof HTMLDialogElement
}

export function initModals() {
    document.body.addEventListener('click', (e: MouseEvent) => {
        let target = e.target
        if (!(target instanceof HTMLElement)) return
        let btn = target.closest('[data-dialog]')

        if (btn) {
            let id = btn.getAttribute('data-dialog')
            let dialog = document.querySelector(`#${id}`)
            if (isDialog(dialog)) {
                dialog.showModal()
            }
        }

        if (target instanceof HTMLDialogElement) {
            // as long as dialog el's padding = 0 and we keep its content in an inner element,
            // this only triggers when clicking on the backdrop
            target.close()
        }

        let closeBtn = target.closest('.orbt-dialog-close')
        if (closeBtn) {
            let dialog = target.closest('dialog')
            if (isDialog(dialog)) {
                dialog.close()
            }
        }
    })
}
